import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../src/components/ui/accordion";
import React from "react";

interface footerMenuItem {
  id: number;
  name: string;
  link: string;
}
export default function FooterMenuAccordion({
  title,
  items,
}: {
  title: string;
  items: footerMenuItem[];
}) {
  return (
    <Accordion
      type="single"
      collapsible
      className="w-full text-sm sm:hidden block"
    >
      <AccordionItem
        value={title}
        className="data-[state=open]:border-b-0 border-b-0"
      >
        <AccordionTrigger className="font-montserrat font-medium text-md hover:underline-none">
          {title}
        </AccordionTrigger>

        <AccordionContent className="flex flex-col gap-4">
          {items?.map((item: footerMenuItem) => (
            <Link
              key={item.id}
              to={item.link}
              className="text-[12px]"
            >
              {item.name}
            </Link>
          ))}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
